<template>
  <div v-if="!isMobile()">
    <div
      class="section section-arenametric"
      id="arenametric-section"
      data-background-color="orange"
    >
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-9">
            <h3 data-aos="fade-up" class="title deco2">
              {{ $t(`TOKEN METRIC`) }}
            </h3>
          </div>
        </div>
        <div class="row" style="width: 100%; margin-left: 0%; margin-top: 40px;">
          <div class="col-lg-5">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/graph_01.png'" width="100%" />
            </div>
          </div>
          <div class="col-lg-2">
            <div
              class="col-lg-12"
              style="padding-left: 70px;"
            >
              <img v-lazy="'/img/line.png'"/>
            </div>
          </div>
          <div class="col-lg-5">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/graph_02.png'" width="100%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-arenametric"
      id="arenametric-section"
      data-background-color="orange"
    >
      <div class="container" style="width: 85%;">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-9">
            <h3 class="title deco2" style="margin-top: 30px;">
              {{ $t(`TOKEN METRIC`) }}
            </h3>
          </div>
        </div>
        <div class="row" style="width: 100%; margin-left: 0%; margin-top: 20px;">
          <div class="col-lg-6">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/graph_01.png'" width="100%" />
            </div>
          </div>
          <div class="col-lg-6">
            <div
              class="col-lg-12"
              style="padding: 0px;"
            >
              <img v-lazy="'/img/graph_02.png'" width="100%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goArena() {
      let url = "//play.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
  },
};
</script>
<style></style>
